module.exports = {
  "zones": {
    "America/Glace_Bay": ["z", {
      "wallclock": 126230400000,
      "format": "A%sT",
      "abbrev": "AST",
      "offset": -14400000,
      "posix": 126244800000,
      "save": 0,
      "rules": "Canada"
    }, {
      "wallclock": 63072000000,
      "format": "A%sT",
      "abbrev": "AST",
      "offset": -14400000,
      "posix": 63086400000,
      "save": 0,
      "rules": "Halifax"
    }, {
      "wallclock": -504921600000,
      "format": "AST",
      "abbrev": "AST",
      "offset": -14400000,
      "posix": -504907200000,
      "save": 0
    }, {
      "wallclock": -536457600000,
      "format": "A%sT",
      "abbrev": "AST",
      "offset": -14400000,
      "posix": -536443200000,
      "save": 0,
      "rules": "Halifax"
    }, {
      "wallclock": -2131660800000,
      "format": "A%sT",
      "abbrev": "AST",
      "offset": -14400000,
      "posix": -2131646412000,
      "save": 0,
      "rules": "Canada"
    }, {
      "wallclock": -1.7976931348623157e+308,
      "format": "LMT",
      "abbrev": "LMT",
      "offset": -14388000,
      "posix": -1.7976931348623157e+308,
      "save": 0
    }]
  },
  "rules": {
    "Canada": [{
      "from": 2007,
      "to": 1.7976931348623157e+308,
      "month": 2,
      "day": [0, 8],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 2007,
      "to": 1.7976931348623157e+308,
      "month": 10,
      "day": [0, 1],
      "time": 120,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1975,
      "to": 2006,
      "month": 9,
      "day": [0, -31],
      "time": 120,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1987,
      "to": 2006,
      "month": 3,
      "day": [0, 1],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1974,
      "to": 1986,
      "month": 3,
      "day": [0, -30],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1974,
      "to": 1974,
      "month": 9,
      "day": [0, -31],
      "time": 120,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1945,
      "to": 1945,
      "month": 7,
      "day": [7, 14],
      "time": 1380,
      "clock": "posix",
      "save": 60,
      "letter": "P",
      "saved": 3600000
    }, {
      "from": 1945,
      "to": 1945,
      "month": 8,
      "day": [7, 30],
      "time": 120,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1942,
      "to": 1942,
      "month": 1,
      "day": [7, 9],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "W",
      "saved": 0
    }, {
      "from": 1918,
      "to": 1918,
      "month": 3,
      "day": [7, 14],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1918,
      "to": 1918,
      "month": 9,
      "day": [7, 27],
      "time": 120,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }],
    "Halifax": [{
      "from": 1962,
      "to": 1973,
      "month": 3,
      "day": [0, -30],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1962,
      "to": 1973,
      "month": 9,
      "day": [0, -31],
      "time": 120,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1956,
      "to": 1959,
      "month": 3,
      "day": [0, -30],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1956,
      "to": 1959,
      "month": 8,
      "day": [0, -30],
      "time": 120,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1951,
      "to": 1954,
      "month": 3,
      "day": [0, -30],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1951,
      "to": 1954,
      "month": 8,
      "day": [0, -30],
      "time": 120,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1946,
      "to": 1949,
      "month": 3,
      "day": [0, -30],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1946,
      "to": 1949,
      "month": 8,
      "day": [0, -30],
      "time": 120,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1937,
      "to": 1941,
      "month": 8,
      "day": [1, 24],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1940,
      "to": 1941,
      "month": 4,
      "day": [0, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1939,
      "to": 1939,
      "month": 4,
      "day": [7, 28],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1937,
      "to": 1938,
      "month": 4,
      "day": [0, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1936,
      "to": 1936,
      "month": 5,
      "day": [7, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1936,
      "to": 1936,
      "month": 8,
      "day": [7, 14],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1935,
      "to": 1935,
      "month": 5,
      "day": [7, 2],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1935,
      "to": 1935,
      "month": 8,
      "day": [7, 30],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1934,
      "to": 1934,
      "month": 4,
      "day": [7, 20],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1934,
      "to": 1934,
      "month": 8,
      "day": [7, 16],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1933,
      "to": 1933,
      "month": 3,
      "day": [7, 30],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1933,
      "to": 1933,
      "month": 9,
      "day": [7, 2],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1931,
      "to": 1932,
      "month": 8,
      "day": [1, 24],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1932,
      "to": 1932,
      "month": 4,
      "day": [7, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1928,
      "to": 1931,
      "month": 4,
      "day": [0, 8],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1930,
      "to": 1930,
      "month": 8,
      "day": [7, 15],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1929,
      "to": 1929,
      "month": 8,
      "day": [7, 3],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1928,
      "to": 1928,
      "month": 8,
      "day": [7, 9],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1927,
      "to": 1927,
      "month": 4,
      "day": [7, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1927,
      "to": 1927,
      "month": 8,
      "day": [7, 26],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1926,
      "to": 1926,
      "month": 4,
      "day": [7, 16],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1926,
      "to": 1926,
      "month": 8,
      "day": [7, 13],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1923,
      "to": 1925,
      "month": 4,
      "day": [0, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1925,
      "to": 1925,
      "month": 8,
      "day": [7, 28],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1924,
      "to": 1924,
      "month": 8,
      "day": [7, 15],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1923,
      "to": 1923,
      "month": 8,
      "day": [7, 4],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1921,
      "to": 1922,
      "month": 8,
      "day": [7, 5],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1922,
      "to": 1922,
      "month": 3,
      "day": [7, 30],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1921,
      "to": 1921,
      "month": 4,
      "day": [7, 6],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1920,
      "to": 1920,
      "month": 4,
      "day": [7, 9],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1920,
      "to": 1920,
      "month": 7,
      "day": [7, 29],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1916,
      "to": 1916,
      "month": 3,
      "day": [7, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1916,
      "to": 1916,
      "month": 9,
      "day": [7, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }]
  }
};